export const ScrollType = {
    SELECTOR: 'SELECTOR',
    TOP: 'TOP',
    BOTTOM: 'BOTTOM',
    MOVE: 'MOVE',
} as const

export type ScrollTypeType = Constant<typeof ScrollType>
